import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import fetchHandler from "@/fetch/fetchHandler";
import { distributeRole } from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class DispatchRoleModal extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.dispatchRoleModal;
    this.state = {
      tableConfig: null,
    };
  }

  componentWillMount() {
    const defaultSource = this.context.store.getState().modalInfo.param.defaultSource;
    this.context.store.getState().modalInfo.param.defaultSource = JSON.parse(JSON.stringify(defaultSource).replace(/id/g, "key").replace(/name/g, "title").replace(/childList/g, "children"));
    this.formConfig = {
      childItems: [
        {
          type: "transfer",
          transType: "default",
          titles: [this.internationalization.title1, this.internationalization.title2],
          placeholder: this.internationalization.placeholder1, // '请输入搜索内容',
          nofound: this.internationalization.msg1, // '暂无选项',
          itemUnit: this.internationalization.dw1, // '项',
          // 通过参数key来配置source和target
          key: ["defaultSource", "defaultTarget"],
          param: {
            name: "roleIds",
            type: "array",
          },
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '确定'
            },
            {
              btnType: "reset",
              text: this.internationalization.btn2, // '清空'
            },
          ],
        },
      ],
      layout: "horizontal", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "modal", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
    };
  }

  fetchApi = (params) => {
    if (this.formConfig.formTarget === "grid") {
      return;
    }

    return fetchHandler(distributeRole, {
      roleIds: params.roleIds,
      userId: this.context.store.getState().modalInfo.param.userId,
    }).then((res) => {
      if (res.code === "success") {
        RefreshGrid(this.context.store, "accountTable");
        window.refreshMenu();
      }
    });
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    };

    render() {
      return (
        <div>
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        </div>);
    }
}

export default injectIntl(DispatchRoleModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/account/dispatchRoleModal.js